module.exports = __webpack_public_path__ + "img/990RecActiveEN2.95816b57.png";